import { Col, Divider, Dropdown, Row, Space } from 'antd';
import { IPortfolio } from 'interface/portfolio.interface';
import React from 'react';

interface IProps {
  portfolio?: IPortfolio;
}
export default function MainInfo(props: IProps): JSX.Element {
  const { portfolio } = props;
  return (
    <>
      <div
        className="text-primary-50"
        style={{ fontSize: '18px', fontWeight: 'bold' }}
      >
        Thông tin danh mục
      </div>
      <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        justify="end"
        className="mb-1 mt-4"
      >
        <Col span={3} className="">
          <div className="text-sm font-semibold text-neutral-70">
            <div>Người tạo</div>
          </div>
        </Col>
        <Col span={9} className="">
          <span className="text-sm font-semibold text-neutral-40">
            {portfolio?.user_created?.fullName}
          </span>
        </Col>

        <Col span={3} className="">
          <span className="text-sm font-semibold text-neutral-70">
            <div>Email </div>
          </span>
        </Col>
        <Col span={9} className="">
          <span className="text-sm font-semibold text-neutral-40">
            {portfolio?.user_created?.email}
          </span>
        </Col>
      </Row>
      <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        justify="end"
        className="mb-1 mt-4"
      >
        <Col span={3} className="">
          <div className="text-sm font-semibold text-neutral-70">
            <div>Chức danh</div>
          </div>
        </Col>
        <Col span={9} className="">
          <span className="text-sm font-semibold text-neutral-40">
            {portfolio?.user_created?.jobTitle}
          </span>
        </Col>

        <Col span={3} className="">
          <span className="text-sm font-semibold text-neutral-70">
            <div>Bộ phận phát triển quản lý </div>
          </span>
        </Col>
        <Col span={9} className="">
          <span className="text-sm font-semibold text-neutral-40">
            {portfolio?.product_group
              ?.map((group: any) => group.grp_name)
              .join(', ')}
          </span>
        </Col>
      </Row>
      <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        justify="end"
        className="mb-1 mt-4"
      >
        <Col span={3} className="">
          <span className="text-sm font-semibold text-neutral-70">
            <div>Khối phát hành</div>
          </span>
        </Col>
        <Col span={9} className="">
          <span className="text-sm font-semibold text-neutral-40">
            {portfolio?.user_created?.division}
          </span>
        </Col>
        <Col span={3} className="">
          <span className="text-sm font-semibold text-neutral-70">
            <div>Công ty phát hành</div>
          </span>
        </Col>
        <Col span={9} className="">
          <div className="text-sm font-semibold text-neutral-40">
            {portfolio?.user_created?.organization}
          </div>
        </Col>
      </Row>
      <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        justify="end"
        className="mb-1 mt-4"
      >
        <Col span={3} className="">
          <span className="text-sm font-semibold text-neutral-70">
            <div>Đơn vị phát hành</div>
          </span>
        </Col>
        <Col span={21} className="">
          <span className="text-sm font-semibold text-neutral-40">
            {portfolio?.user_created?.departmentName}
          </span>
        </Col>
      </Row>
      <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        justify="end"
        className="mb-1 mt-4"
      >
        <Col span={3} className="">
          <span className="text-sm font-semibold text-neutral-70">
            <div>Đặt hàng theo Ni</div>
          </span>
        </Col>
        <Col span={21} className="">
          <span className="text-sm font-semibold text-neutral-40">
            {portfolio?.allow_order_ni ? 'Có' : 'Không'}
          </span>
        </Col>
      </Row>
      <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        justify="end"
        className="mb-1 mt-4"
      >
        <Col span={24} className="">
          <span className="text-sm font-semibold text-neutral-70">
            <div>Mô tả</div>
          </span>
        </Col>
      </Row>
      <Row
        gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
        justify="end"
        className="mb-1 mt-4"
      >
        <Col span={24} className="">
          <span>{portfolio?.description}</span>
        </Col>
      </Row>
    </>
  );
}
